document.addEventListener('DOMContentLoaded', () => {
	const queryString = window.location.search;
	const urlParams = new URLSearchParams(queryString);
	const keys = urlParams.keys();
	for (const key of keys) {
		if (key == 'clean') {
			$.ajax({
		      type: "POST",
		      url: '/cart/clear.js',
		      success: function(){
		        if (sessionStorage.getItem('updatePage') == null || sessionStorage.getItem('updatePage') == 'true') {;
					sessionStorage.setItem('updatePage', 'false');
					location.reload();
		        }
		      },
		      dataType: 'json'
		    });
		}
	};
});
